const types = {
    SET_HISTORY_LIST: '[REPORT] SET HISTORY LIST',
    SET_CASHIERS_PROFILE: '[REPORT] SET CASHIERS PROFILE',
    SET_HISTORY_JACKPOT: '[REPORT] SET HISTORY JACKPOT',
    SET_HISTORY_BONUSES: '[REPORT] SET HISTORY BONUSES',
    SET_GGR: '[GGR] SET GGR',
    SET_OPERATION_REPLENISHMENT: '[GGR] SET OPERATIONS REPLENISHMENT', 
    SET_OPERATION_WITHDRAWAL: '[GGR] SET OPERATIONS WITHDRAWAL'
}

export {
    types
}